import { Component, OnInit } from '@angular/core';
import { UserService } from '@rubii/frontend-common';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';

@Component({
  selector: 'app-blis',
  templateUrl: './blis.component.html',
  styleUrls: ['./blis.component.scss']
})
export class BlisComponent extends BaseDatasourceComponent implements OnInit {
  blisEmail = '';

  constructor(private user: UserService) {
    super();
  }

  ngOnInit(): void {
    this.blisEmail = 'report+blis+' + this.user.user.tenant.token + '+' + this.user.user.id + '@rubii.io';
  }
}
